import { useGetMe } from "@entities/Onboarding/lib/hooks/useGetMe";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function useMyPricingUserIdParam() {
  const { userDetails, isSuccess } = useGetMe();
  const currentUserId = userDetails?.userEntity?.id ?? "";
  const [searchParams, setSearchParams] = useSearchParams();
  const userIdParam = searchParams.get("userId") ?? "";

  const setUserIdParam = (userId: string) => {
    setSearchParams({ userId });
  };

  useEffect(() => {
    if (!isSuccess || !currentUserId || userIdParam) {
      return;
    }

    setSearchParams({ userId: currentUserId }, { replace: true });
  }, [isSuccess, currentUserId, userIdParam, setSearchParams]);

  return {
    userDetails,
    isSuccess,
    currentUserId,
    userIdParam,
    setUserIdParam,
    isSuperUser: Boolean(
      userDetails?.userEntity?.permissions?.includes("super") ||
      userDetails?.userEntity?.permissions?.includes("allocate-pricing")
    ),
  };
}
